<template>
  <!--<div>-->
  <div class="mobileBox">
    <!--banner+导航-->
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/instoreBanner_m.png"/>

      <top-nav></top-nav>

    </div>

    <div class="instoreContent">
      <div class="">
        <div class="rightTopImg" id="m1"><img :class="animates.mm1 ? 'fadeInUp animated' : 'hideBox'" src="../../../assets/img/instoreImg1.png"/></div>
        <div class="contentsTextBox">
          <div class="instore01"></div>
          <div class="instore02" id="m2">
            <div class="leftBox animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
              <div class="leftBorder"></div>
              <div class="textBox">
                <div class="texts">
                  <div class="titles">INSTORE SOLUTION</div>
                  <div class="contents">We provide various payment solutions for physical stores, enabling customers to pay with Alipay or WeChat Pay on spot.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="instore03">

            <div class="instore03_row" id="m3">
              <div class="instore03_left animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
                <div class="titles">Merchant QR code</div>
                <div class="contents">Customers can scan the static QR code to make a payment. Customers are required to enter the price themselves.</div>
              </div>

              <!--<ul class="instore03_ul animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">-->
                <!--<li class="instore03_li">-->
                  <!--<div class="topText">Scan QR code with Alipay or WeChat</div>-->
                  <!--<div class="bottomIcon"><img src="../../../assets/icon/instore_row1_icon1.png"/></div>-->
                <!--</li>-->
                <!--<li class="instore03_li">-->
                  <!--<div class="topText">Enter the amount of purchase</div>-->
                  <!--<div class="bottomIcon"><img src="../../../assets/icon/instore_row1_icon2.png"/></div>-->
                <!--</li>-->
                <!--<li class="instore03_li">-->
                  <!--<div class="topText">Enter the password</div>-->
                  <!--<div class="bottomIcon"><img src="../../../assets/icon/instore_row1_icon3.png"/></div>-->
                <!--</li>-->
                <!--<li class="instore03_li">-->
                  <!--<div class="topText">Payment successful</div>-->
                  <!--<div class="bottomIcon"><img src="../../../assets/icon/instore_row1_icon4.png"/></div>-->
                <!--</li>-->
              <!--</ul>-->
              <div class="animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
              <div class="swiper-container animated">
                <div class="swiper-wrapper instore03_ul">
                  <div class="swiper-slide instore03_li">
                    <div class="topText">Scan QR code with Alipay or WeChat</div>
                    <div class="bottomIcon"><img src="../../../assets/icon/instore_row1_icon1.png"/></div>
                  </div>
                  <div class="swiper-slide instore03_li">
                    <div class="topText">Enter the amount of purchase</div>
                    <div class="bottomIcon"><img src="../../../assets/icon/instore_row1_icon2.png"/></div>
                  </div>
                  <div class="swiper-slide instore03_li">
                    <div class="topText">Enter the password</div>
                    <div class="bottomIcon"><img src="../../../assets/icon/instore_row1_icon3.png"/></div>
                  </div>
                  <div class="swiper-slide instore03_li">
                    <div class="topText">Payment successful</div>
                    <div class="bottomIcon"><img src="../../../assets/icon/instore_row1_icon4.png"/></div>
                  </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination"></div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
                <!-- 如果需要滚动条 -->
                <!--<div class="swiper-scrollbar"></div>-->
              </div>
              </div>

            </div>

            <div class="instore03_row" id="m4">
              <div class="instore03_left animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
                <div class="titles">Smart Device</div>
                <div class="contents">A smart device allows the merchant to create QR code for the customer to scan or to scan the customer's payment code.</div>
              </div>

              <div class="animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
                <div class="swiper-container">
                  <div class="swiper-wrapper instore03_ul">
                    <div class="swiper-slide instore03_li">
                      <div class="topText">Enter the price of the merchandise </div>
                      <div class="bottomIcon"><img src="../../../assets/icon/instore_row2_icon1.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">The device generate a QR code for the customer to scan</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/instore_row2_icon2.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">Or to scan the consumer's payment code with the device</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/instore_row2_icon3.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">Payment successful</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/instore_row2_icon4.png"/></div>
                    </div>
                  </div>
                  <!-- 如果需要分页器 -->
                  <div class="swiper-pagination"></div>
                  <!-- 如果需要导航按钮 -->
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                  <!-- 如果需要滚动条 -->
                  <!--<div class="swiper-scrollbar"></div>-->
                </div>
              </div>

            </div>
            <div class="instore03_row" id="m5">
              <div class="instore03_left animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
                <div class="titles">POS Terminal</div>
                <div class="contents">We can integrate SuperiorPay with existing POS terminals.</div>
              </div>

             <!-- <ul class="instore03_ul animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
                <li class="instore03_li">
                  <div class="topText">Enter the price of the merchandise </div>
                  <div class="bottomIcon"><img src="../../../assets/icon/instore_row3_icon1.png"/></div>
                </li>
                <li class="instore03_li">
                  <div class="topText">1. The device generate a QR code for the customer to scan</div>
                  <div class="bottomIcon"><img src="../../../assets/icon/instore_row3_icon2.png"/></div>
                </li>
                <li class="instore03_li">
                  <div class="topText">Or to scan the consumer's payment code with the device</div>
                  <div class="bottomIcon"><img src="../../../assets/icon/instore_row3_icon3.png"/></div>
                </li>
                <li class="instore03_li">
                  <div class="topText">Payment successful</div>
                  <div class="bottomIcon"><img src="../../../assets/icon/instore_row3_icon4.png"/></div>
                </li>
              </ul>-->

              <div class="animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
                <div class="swiper-container">
                  <div class="swiper-wrapper instore03_ul">
                    <div class="swiper-slide instore03_li">
                      <div class="topText">Enter the price of the merchandise </div>
                      <div class="bottomIcon"><img src="../../../assets/icon/instore_row3_icon1.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">1. The device generate a QR code for the customer to scan</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/instore_row3_icon2.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">Or to scan the consumer's payment code with the device</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/instore_row3_icon3.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">Payment successful</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/instore_row3_icon4.png"/></div>
                    </div>
                  </div>
                  <!-- 如果需要分页器 -->
                  <div class="swiper-pagination"></div>
                  <!-- 如果需要导航按钮 -->
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                  <!-- 如果需要滚动条 -->
                  <!--<div class="swiper-scrollbar"></div>-->
                </div>
              </div>

            </div>
          </div>
          <div class="instore04" id="m6">
            <ul class="instore04_ul animated" :class="animates.mm6 ? 'fadeInUp' : 'hideBox'">
              <li class="instore04_li">
                <div class="iconBox"><img src="../../../assets/icon/instore_row4_icon1.png"/></div>
                <div class="titles">“T + 1” Settlement</div>
                <div class="contents">Automatically settle your trading volume in “T+1” business days.</div>
              </li>
              <li class="instore04_li">
                <div class="iconBox"><img src="../../../assets/icon/instore_row4_icon2.png"/></div>
                <div class="titles">Bank-grade Fund Security</div>
                <div class="contents">We are authorised with the Australian financial license, and strictly comply with AML (Anti Money Laundering) and AF (Anti-Fraud) regulations for risk control.</div>
              </li>
              <li class="instore04_li">
                <div class="iconBox"><img src="../../../assets/icon/instore_row4_icon3.png"/></div>
                <div class="titles">Web + App Account Management</div>
                <div class="contents">One-stop financial data management with convenient back-stage operation and complete statistical functions.</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--底部-->
    <div class="footer_m ">
      <div class="footer_mText">
        Supay Technology Pty Ltd. Authorized Representative Number 001283947
        <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
      </div>
    </div>

  </div>
  <!--</div>-->
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import topNav from './nav_m'
  let timer = null; //定义初始值
  export default {
    name: "PaymentInstore_m",
    components:{topNav},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        animates:{
          mm1:false,
          mm2:false,
          mm3:false,
          mm4:false,
          mm5:false,
          mm6:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      new Swiper('.swiper-container', {
        loop:true,
        autoplay:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          el:".swiper-pagination",
          clickable:true,
        },
        navigation:{
          prevEl:".swiper-button-prev",
          nextEl:".swiper-button-next",
        }
      });

      document.documentElement.scrollTop=0;

      this.animates.mm1 = true;
      this.animates.mm2 = true;
      this.animates.mm3 = true;
      window.addEventListener('scroll', this.handleScroll)

    },
    methods:{
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        // var offsetTop1 = document.querySelector('#m1').offsetTop;
        // var offsetTop2 = document.querySelector('#m2').offsetTop;
        // var offsetTop3 = document.querySelector('#m3').offsetTop;
        var offsetTop4 = document.querySelector('#m4').offsetTop;
        var offsetTop5 = document.querySelector('#m5').offsetTop;
        var offsetTop6 = document.querySelector('#m6').offsetTop;



        if (scrollTop > offsetTop4-220) {
          this.animates.mm4 = true
        } else {
          this.animates.mm4 = false
        }
        if (scrollTop > offsetTop5-220) {
          this.animates.mm5 = true
        } else {
          this.animates.mm5 = false
        }
        if (scrollTop > offsetTop6-220) {
          this.animates.mm6 = true
        } else {
          this.animates.mm6 = false
        }
      },

      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>
  .instoreContent .swiper-container {
    width: 100%;
    height: auto;
    padding-bottom: 40px;
  }

  /*body{min-width: 1345px;}*/
  .mobileBox{width: 100%;height: auto;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}

  .instore04{width: 100%;height: auto;padding: 5rem 0;}
  .instore04 .instore04_ul{width: 100%;height: auto;}
  .instore04 .instore04_ul .instore04_li{width:calc(100% - 100px);height: auto;padding: 40px 50px;}
  .instore04 .instore04_ul .instore04_li .iconBox{width: 100%;height: 10rem;text-align: center;}
  .instore04 .instore04_ul .instore04_li .iconBox>img{max-height: 100%;}
  .instore04 .instore04_ul .instore04_li .titles{font-size: 1rem;color: #4a4a4a;font-family: MontserratMedium;width: 100%;text-align: center;line-height: 2rem;}
  .instore04 .instore04_ul .instore04_li .contents{font-size: 0.875rem;font-family: Montserrat300;color: #4a4a4a;width: 100%;text-align: center;line-height: 1.8rem;margin-top: 1rem;}




  /*内容部分*/
  .instoreContent{width: 100%;height: auto;padding: 1rem 0 0rem 0;background-color: #fff;}
  .instoreContent .rightTopImg{position: absolute;width: 90%;height: auto;text-align: right;right: 0;z-index: 1;max-width: 650px;}
  .instoreContent .rightTopImg>img{width: 100%}


  .instoreContent .contentsTextBox{width: 100%;height: auto;position: relative;z-index: 2;}
  .instore01{width: 100%;height: 7rem;}
  .instore02{width: 100%;height: auto;min-height: 7rem;}
  .instore02 .leftBox{width: calc(100% - 30px);box-shadow: 0 0 15px 1px rgba(0,0,0,0.3);padding: 1rem 0; margin-left:15px;float: left;height: 100%;background-color: #fff;position: relative;display: flex;align-items: center;}
  .instore02 .leftBox .leftBorder{align-items: center;width: 4px;height: 70px;background-color: #0076ff;}
  .instore02 .leftBox .textBox{width: 80%;height: calc(100% - 2px);display: flex;align-items: center;margin-left: 2rem;}
  .instore02 .leftBox .textBox .texts{width: 100%;height: 60%;margin: auto;align-items: center;}
  .instore02 .leftBox .textBox .texts .titles{font-size: 1.125rem;font-family: OpenSans600;line-height: 2rem;color: #6d7278;}
  .instore02 .leftBox .textBox .texts .contents{font-size: 0.75rem;font-family: Montserrat300;color: #6d7278;line-height: 1.3rem;}



  .instore03{width: 100%;height: auto;background-color: #fff;}
  .instore03 .instore03_row{width: calc(100% - 30px);height: auto;padding: 60px 15px;}
  .instore03 .instore03_row .instore03_left{width: 70%;height: 100%;margin: auto;}
  .instore03 .instore03_row .instore03_left .titles{color: #6d7278;font-size: 1rem;font-family: Montserrat600;line-height: 3rem;text-align: center;}
  .instore03 .instore03_row .instore03_left .contents{font-size: 0.875rem;font-family: Montserrat300;color: #6d7278;line-height: 1.6rem;text-align: center;}
  .instore03 .instore03_row .instore03_ul{width: 100%;height: auto;margin-top: 50px;}
  .instore03 .instore03_row .instore03_ul .instore03_li{width: 100%;height: 100%;padding: 0;}
  .instore03 .instore03_row .instore03_ul .instore03_li .topText{width: 9rem;height: 3rem;margin: auto; font-family: Montserrat300;font-size: 0.875rem;color: #6d7278;line-height: 1.1rem;text-align: center;}
  .instore03 .instore03_row .instore03_ul .instore03_li .bottomIcon{width: 100%;height: 13rem;display: flex;align-items: center;}
  .instore03 .instore03_row .instore03_ul .instore03_li .bottomIcon>img{max-width: 100%;max-height: 100%;align-items: center;margin: auto;}

  .hideBox{display: none;}

</style>
